import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { DocumentTypeCodeDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';


@Component({
  selector: 'cradua-documenttypecode-container',
  templateUrl: './documenttypecode-container.component.html',
  styleUrls: ['./documenttypecode-container.component.scss']
})
export class DocumentTypeCodeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  documenttypecodes$: Observable<DocumentTypeCodeDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("DocumentTypeCode");
    this.documenttypecodes$ = this.gatwayFacade.loadGateway("DocumentTypeCode");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDocumentTypeCode(deletedValue: any) {
    this.gatwayFacade.remove("DocumentTypeCode", deletedValue);
    // this.store.dispatch(DocumentTypeCodeStoreActions.removeDocumentTypeCode({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitDocumentTypeCode(formValue: any) {
    console.log("form value: ", formValue);
    formValue.DocumentTypeCodes = formValue.DocumentTypeCodes.reverse();
    event.preventDefault();
    const pullData = formValue.DocumentTypeCodes;
    //const newPullData = formValue.DocumentTypeCodees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllDocumentTypeCode = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllDocumentTypeCode.push(pullData[i]);
    }
  }

// check if the addAllDocumentTypeCode array is not empty, then dispatch the data to the store
   if(addAllDocumentTypeCode.length !== 0) {
    this.gatwayFacade.add('DocumentTypeCode', addAllDocumentTypeCode);
    // this.store.dispatch(DocumentTypeCodeStoreActions.addDocumentTypeCode({newDocumentTypeCode: addAllDocumentTypeCode}));

   }

// dispatch update data to the store
this.gatwayFacade.update('DocumentTypeCode', allUpdates, ['id']);
    // this.store.dispatch(DocumentTypeCodeStoreActions.updateDocumentTypeCode({updateDocumentTypeCode: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}


